import { isNotNil } from '@flowio/is';

/**
 * Creates a style element and injects it into the DOM tree.
 * @returns A function that removes the injected style element from the
 * DOM tree when called.
 */
export default function injectCss(css, options) {
  var element = document.createElement('style');
  element.setAttribute('type', 'text/css');
  element.textContent = css;
  var head = document.getElementsByTagName('head')[0];

  if (isNotNil(head)) {
    if (options && options.prepend) {
      if (head.childNodes[0]) {
        head.insertBefore(element, head.childNodes[0]);
      } else {
        head.appendChild(element);
      }
    } else {
      head.appendChild(element);
    }
  }

  return function ejectCss() {
    if (isNotNil(head)) head.removeChild(element);
  };
}
//# sourceMappingURL=injectCss.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@flowio/postmessage/~/@flowio/browser-helpers/lib/esm/injectCss.js
// module id = 670
// module chunks = 0 1